<script setup lang="ts">
import Api from "@/services/api/ApiServiceFabrick"
import { Ref, ref, watch, onMounted } from 'vue'
import { firstFile } from '@/services/functions'

const props = defineProps<{
  image: string | null
  newImage: any
  modelName: string
  modelId: number
}>()

const url: Ref<string | null> = ref(null)

function getUrl() {
  if (!props.image || !props.modelId) return
  Api().getFileUrl(props.modelName, props.modelId).then((data) => {
    url.value = data
  })
}

function getFileUrl(file: any) {
  if (!file) return
  return URL.createObjectURL(file);
}

onMounted(() => {
  getUrl()
})
</script>
<template>
  <template v-if="firstFile(props.newImage)">
    <img :src="getFileUrl(firstFile(props.newImage))" width="300">
  </template>
  <template v-else>
    <img v-if="url" :src="url" width="300">
  </template>
</template>

<style scoped>
img {
  border: solid 1px #ddd;
  border-radius: 4px;
  padding: 4px;
  margin: 1vw;
}
</style>
